import listActions from '../../../modules/hashtag/list/hashtagListActions'
import HashtagService from '../../../modules/hashtag/hashtagService'
import Errors from '../../../modules/shared/error/errors'
import { i18n } from '../../../i18n'
import { push } from 'redux-first-history'
import Message from '../../../view/shared/message'

const prefix = 'HASHTAG_DESTROY'

const hashtagDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: hashtagDestroyActions.DESTROY_STARTED,
      })

      await HashtagService.destroyAll([id])

      dispatch({
        type: hashtagDestroyActions.DESTROY_SUCCESS,
      })

      Message.success(
        i18n('entities.hashtag.destroy.success'),
      )

      dispatch(listActions.doFetchCurrentFilter())

      dispatch(push('/hashtag'))
    } catch (error) {
      Errors.handle(error)

      dispatch(listActions.doFetchCurrentFilter())

      dispatch({
        type: hashtagDestroyActions.DESTROY_ERROR,
      })
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: hashtagDestroyActions.DESTROY_ALL_STARTED,
      })

      await HashtagService.destroyAll(ids)

      dispatch({
        type: hashtagDestroyActions.DESTROY_ALL_SUCCESS,
      })

      if (listActions) {
        dispatch(listActions.doClearAllSelected())
        dispatch(listActions.doFetchCurrentFilter())
      }

      Message.success(
        i18n('entities.hashtag.destroyAll.success'),
      )

      dispatch(push('/hashtag'))
    } catch (error) {
      Errors.handle(error)

      dispatch(listActions.doFetchCurrentFilter())

      dispatch({
        type: hashtagDestroyActions.DESTROY_ALL_ERROR,
      })
    }
  },
}

export default hashtagDestroyActions
